import axios from "axios";

export const API = "https://api.orderly.ro";
// local dev: export const API = "http://localhost:4000";

const getHeaders = () => ({ "hub-token": localStorage.getItem("hubToken") || "" });

// Redirect to /login on 401 (expired or invalid token)
axios.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem("hubToken");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export const hubApi = {
  login:      (data)          => axios.post(`${API}/hub/auth/login`, data),
  verifyOtp:  (data)          => axios.post(`${API}/hub/auth/verify-otp`, data),

  getAll:     ()              => axios.get(`${API}/hub/restaurants`,              { headers: getHeaders() }),
  getOne:     (id)            => axios.get(`${API}/hub/restaurants/${id}`,        { headers: getHeaders() }),
  create:     (data)          => axios.post(`${API}/hub/restaurants`, data,       { headers: getHeaders() }),
  update:     (id, data)      => axios.put(`${API}/hub/restaurants/${id}`, data,  { headers: getHeaders() }),
  toggle:     (id)            => axios.post(`${API}/hub/restaurants/${id}/toggle`, {}, { headers: getHeaders() }),
  billing:    (id, data)      => axios.put(`${API}/hub/restaurants/${id}/billing`, data, { headers: getHeaders() }),
  markPaid:   (id)            => axios.post(`${API}/hub/restaurants/${id}/mark-paid`, {}, { headers: getHeaders() }),
  uploadInvoice: (id, file)   => {
    const fd = new FormData();
    fd.append("invoice", file);
    return axios.post(`${API}/hub/restaurants/${id}/upload-invoice`, fd, {
      headers: { ...getHeaders(), "Content-Type": "multipart/form-data" },
    });
  },
  addNote:    (id, text)      => axios.post(`${API}/hub/restaurants/${id}/notes`, { text }, { headers: getHeaders() }),
  deleteNote: (id, noteId)    => axios.delete(`${API}/hub/restaurants/${id}/notes/${noteId}`, { headers: getHeaders() }),
  getCustomization:    (id)        => axios.get(`${API}/hub/restaurants/${id}/customization`,         { headers: getHeaders() }),
  updateCustomization: (id, data)  => axios.put(`${API}/hub/restaurants/${id}/customization`, data,   { headers: getHeaders() }),
  getAccounts:         (id)        => axios.get(`${API}/hub/restaurants/${id}/accounts`,              { headers: getHeaders() }),
  createAccount:       (id, data)  => axios.post(`${API}/hub/restaurants/${id}/accounts`, data,       { headers: getHeaders() }),
};

// Plan pricing reference
export const PLAN_PRICING = {
  1: { name: "Light",      monthly: 49,  quarterly: 130, yearly: 470,  color: "#3b82f6", bg: "#eff6ff", border: "#bfdbfe" },
  2: { name: "Pro",        monthly: 99,  quarterly: 267, yearly: 950,  color: "#7c3aed", bg: "#f5f3ff", border: "#ddd6fe" },
  3: { name: "Enterprise", monthly: 199, quarterly: 537, yearly: 1910, color: "#ea580c", bg: "#fff7ed", border: "#fed7aa" },
};

export const BILLING_PERIOD_LABEL = {
  monthly:   "Lunar",
  quarterly: "Trimestrial",
  yearly:    "Anual",
};

export const STATUS_STYLE = {
  paid:    { bg: "#f0fdf4", color: "#16a34a", border: "#bbf7d0", label: "Plătit",          dot: "#16a34a" },
  pending: { bg: "#fffbeb", color: "#d97706", border: "#fde68a", label: "În așteptare",    dot: "#d97706" },
  overdue: { bg: "#fff1f2", color: "#e11d48", border: "#fecdd3", label: "Restanță",        dot: "#e11d48" },
};

// ── Client accounts & tickets ──────────────────────────────────
export const hubExt = {
  getClientAccounts: ()                    => axios.get(`${API}/hub/client-accounts`,                      { headers: getHeaders() }),
  patchClientAccount: (id, data)           => axios.patch(`${API}/hub/client-accounts/${id}`, data,        { headers: getHeaders() }),
  getAllTickets: ()                         => axios.get(`${API}/hub/tickets`,                              { headers: getHeaders() }),
  replyTicket: (userId, ticketId, reply)   => axios.patch(`${API}/hub/tickets/${userId}/${ticketId}/reply`, { reply }, { headers: getHeaders() }),
  setTicketStatus: (userId, ticketId, status) => axios.patch(`${API}/hub/tickets/${userId}/${ticketId}/status`, { status }, { headers: getHeaders() }),
  getUpdateNotes: ()                       => axios.get(`${API}/hub/update-notes`,                         { headers: getHeaders() }),
  createUpdateNote: (data)                 => axios.post(`${API}/hub/update-notes`, data,                  { headers: getHeaders() }),
  updateUpdateNote: (id, data)             => axios.put(`${API}/hub/update-notes/${id}`, data,              { headers: getHeaders() }),
  deleteUpdateNote: (id)                   => axios.delete(`${API}/hub/update-notes/${id}`,                { headers: getHeaders() }),
};

export const calcFinalAmount = (plan, period, discountType, discountValue) => {
  const pricing = PLAN_PRICING[plan] || PLAN_PRICING[1];
  const base = pricing[period] || pricing.monthly;
  if (discountType === "percent") return +(base * (1 - discountValue / 100)).toFixed(2);
  if (discountType === "fixed")   return +(Math.max(0, base - discountValue)).toFixed(2);
  return base;
};
